var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',{staticStyle:{"position":"relative"}},[_c('router-view',{staticStyle:{"paddingBottom":"100px"}}),_c('dashboard-core-footer',{attrs:{"footerPosition":"position:absolute;bottom:0;width: 100%;"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }